import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cf15eca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "Search_item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "计划日期", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_5 = { class: "Search_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "申请单类型", -1))
const _hoisted_7 = { class: "Search_item_content" }
const _hoisted_8 = { class: "tag" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_search_x" }, null, -1))
const _hoisted_11 = { class: "content_total" }
const _hoisted_12 = { class: "content_list" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "content_list_item_title" }
const _hoisted_15 = {
  key: 0,
  class: "yellow"
}
const _hoisted_16 = {
  key: 1,
  class: "green"
}
const _hoisted_17 = {
  key: 2,
  class: "red"
}
const _hoisted_18 = {
  key: 3,
  class: "red"
}
const _hoisted_19 = { class: "content_list_item_dj" }
const _hoisted_20 = { class: "content_list_item_content" }

import { reactive, ref, onMounted } from "vue"
    import { useRouter } from "vue-router"
    import { gsdate, judgmentPlatform } from '@/utils/utils'
    import { sqdCage } from '@/apis/WorkOrderAPI'
    import { model } from '@/interface'
    import vSearch from '@/components/common/Search.vue'
    import vLableSelection from '@/components/common/LabelSelection.vue'

    interface form extends model {
        startDate: string,
        endDate: string,
        total: number,
        type: string,
        statusList: string
    }

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()

    // 搜索数据接口
    const form = reactive<form>({
        capacity: 10,
        page: 0,
        total: 0,
        startDate: '',
        endDate: '',
        mixParam: '',
        type: '',
        statusList: '0'
    })

    // 申请单类型
    let tyoe = ref<Array<any>>([
        { name: '工序返工', id: '0', active: false },
        { name: '客返品返修', id: '2', active: false },
        { name: '客退品返修', id: '1', active: false },
        { name: '工序报废', id: '3', active: false }
    ])

    const minDate: Date = new Date(2021, 0, 1)

    const maxDate: Date = new Date(new Date().getFullYear() + 1, 12, 30)

    let status = ref<boolean>(false)    // 根据平台是否需要设置top

    const isOpenDate = ref(false);

    // 列表数据
    const list: any = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false)

    // 搜索分类标签
    let tagList: any = reactive([
        {
            id: '0',
            name: '待审核',
            num: ''
        },
        {
            id: '1',
            name: '审核通过',
            num: ''
        },
        {
            id: '2',
            name: '审核不通过',
            num: ''
        },
        {
            id: '3',
            name: '已取消',
            num: ''
        }
    ])

    // 跳转新建申请单
    const jumpAdd = () => {

    }

    // 切换单据类型
    const clickItem = (i: number, id: string): void => {
        form.type = id
        tyoe.value.forEach((item: any, index: number) => {
            item.active = i === index;
        })
    }

    // 重置
    const reset = () => {
        form.startDate = ''
        form.endDate = ''
        form.mixParam = ''
        form.page = 0
        form.type = ''
        finished.value = false
        list.value = []
        tyoe.value.forEach((element: any) => { element.active = false })
        onLoad()
    }

    // 搜索框
    const searchInput = (data: any) => {
        form.mixParam = data
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    // 搜索提交
    const submit = (): void => {
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    const openDate = () => {
        isOpenDate.value = true
    }

    // 确认选择日期
    const onConfirm = (values: any) => {
        const [start, end] = values
        form.startDate = gsdate(start)
        form.endDate = gsdate(end)
        isOpenDate.value = false
    };

    // 切换分类
    const clickTag = (id: any): void => {
        form.statusList = id
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    // 获取扫码值
    const onDecode = (data: string[]): void => {
        console.log(data)
    }

    // 跳转详情
    const jump = (item: any) => {
        if (item.type === 0 || item.type === 1 || item.type === 2) {
            router.push({ name: 'reworkDetails', query: { id: item.id } })
        } else if (item.type === 3) {
            router.push({ name: 'scrapDetails', query: { id: item.id } })
        }
    }

    // 获取工单列表数据
    const onLoad = () => {
        if (!finished.value) {
            loading.value = true;
            form.page = form.page + 1
            sqdCage({
                capacity: form.capacity,
                page: form.page,
                model: {
                    queryParam: form.mixParam,
                    startDate: form.startDate,
                    endDate: form.endDate,
                    status: form.statusList,
                    type: form.type
                }
            }).then(res => {
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
                loading.value = false;
                if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
                    form.total = res.data.total
                    list.value.push(...res.data.records)
                } else {
                    finished.value = true;
                }
            }).catch((err: any) => {
                loading.value = false;
                finished.value = true;
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
            })
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        form.page = 0
        loading.value = true;
        onLoad();
    }

    // 查询工单分类数量
    // const pageCounts = () => {
    //     pageCount({}).then(res => {
    //         if (res.code === 200) {
    //             tagList[0].num = String(res.data.startNum)
    //             tagList[1].num = String(res.data.ingNum)
    //             tagList[2].num = String(res.data.endNum)
    //         }
    //     })
    // }

    onMounted(() => {
        status.value = judgmentPlatform()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'content_top': _unref(status) }, "content_search"])
    }, [
      _createVNode(vSearch, {
        onSearchInput: searchInput,
        onSubmit: submit,
        onReset: reset,
        isShow: true,
        placeholder: "搜索申请单的名称/单号"
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "Search_item_content",
              onClick: openDate
            }, [
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(form).startDate ? 'color: #000;' : '')
              }, _toDisplayString(_unref(form).startDate ? _unref(form).startDate : '开始日期'), 5),
              _hoisted_4,
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(form).endDate ? 'color: #000;' : '')
              }, _toDisplayString(_unref(form).endDate ? _unref(form).endDate : '结束日期'), 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tyoe), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag_item", {'tag_active': item.active}]),
                    key: index,
                    onClick: ($event: any) => (clickItem(index, item.id))
                  }, _toDisplayString(item.name), 11, _hoisted_9))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _hoisted_10,
      _createVNode(vLableSelection, {
        TagList: _unref(tagList),
        isShow: true,
        onChange: clickTag
      }, null, 8, ["TagList"])
    ], 2),
    _createElementVNode("div", _hoisted_11, "共" + _toDisplayString(_unref(form).total) + "条数据", 1),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了~",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "content_list_item",
                  key: i,
                  onClick: ($event: any) => (jump(item))
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", null, _toDisplayString(item.title), 1),
                    (item.status === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "待审核"))
                      : (item.status === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "审批通过"))
                        : (item.status === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "审批未通过"))
                          : (item.status === 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "审批终止"))
                            : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", null, "单号：" + _toDisplayString(item.code), 1),
                    _createElementVNode("span", null, "日期：" + _toDisplayString(item.createTime), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString(item.remark), 1)
                  ])
                ], 8, _hoisted_13))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_van_calendar, {
      show: isOpenDate.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((isOpenDate).value = $event)),
      type: "range",
      "min-date": _unref(minDate),
      "max-date": _unref(maxDate),
      color: "#4275FC",
      onConfirm: onConfirm
    }, null, 8, ["show", "min-date", "max-date"])
  ]))
}
}

})